import { WifiOff, RefreshCw, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useConnectionStatus } from '@/hooks/useConnectionStatus';
import { useState } from 'react';

export function ConnectionBanner() {
  const { isOffline, failedRequests, lastError, retryAll, clearErrors } = useConnectionStatus();
  const [isRetrying, setIsRetrying] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  const handleRetry = async () => {
    setIsRetrying(true);
    retryAll();
    // Give a moment for requests to complete
    setTimeout(() => setIsRetrying(false), 1000);
  };

  const handleDismiss = () => {
    setDismissed(true);
    clearErrors();
  };

  // Show banner if offline or has failed requests (and not dismissed)
  if ((!isOffline && failedRequests === 0) || dismissed) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-destructive text-destructive-foreground px-4 py-2 shadow-lg animate-in slide-in-from-top duration-300">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <WifiOff className="h-5 w-5 flex-shrink-0" />
          <div className="text-sm">
            <span className="font-medium">
              {isOffline ? 'Connection lost' : `${failedRequests} request${failedRequests > 1 ? 's' : ''} failed`}
            </span>
            {lastError && (
              <span className="hidden sm:inline ml-2 opacity-80">
                — {lastError.substring(0, 50)}{lastError.length > 50 ? '...' : ''}
              </span>
            )}
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <Button
            variant="secondary"
            size="sm"
            onClick={handleRetry}
            disabled={isRetrying}
            className="bg-destructive-foreground/20 hover:bg-destructive-foreground/30 text-destructive-foreground border-none"
          >
            <RefreshCw className={`h-4 w-4 mr-1 ${isRetrying ? 'animate-spin' : ''}`} />
            Retry All
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleDismiss}
            className="text-destructive-foreground hover:bg-destructive-foreground/20 p-1 h-auto"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
